import { render, staticRenderFns } from "./AdoptionShow.vue?vue&type=template&id=adc70a48&"
import script from "./AdoptionShow.vue?vue&type=script&lang=js&"
export * from "./AdoptionShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports